module.exports = __webpack_public_path__ + "media/images/icons/instagram_blue-22142b4f9c633a3cb43a08cb5a434399.svg";